/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContainerPickupSettingsDTO } from './containerPickupSettingsDTO';
import { CourierServicesTenantConfigurationDTO } from './courierServicesTenantConfigurationDTO';
import { EdiSettingsDTO } from './ediSettingsDTO';
import { ExternalContainersSearchSettingDTO } from './externalContainersSearchSettingDTO';
import { FinanceSettingsDTO } from './financeSettingsDTO';
import { GeneralSettingsDTO } from './generalSettingsDTO';
import { InttraSettingsDTO } from './inttraSettingsDTO';
import { ModuleSettingsDTO } from './moduleSettingsDTO';
import { OnTimeLogisticsSettingsDTO } from './onTimeLogisticsSettingsDTO';
import { OperationalFileSettingsDTO } from './operationalFileSettingsDTO';
import { QuoteFileSettingsDTO } from './quoteFileSettingsDTO';

export interface ClientTenantConfigurationDTO { 
    inttraSettings?: InttraSettingsDTO;
    ediSettings?: EdiSettingsDTO;
    generalSettings?: GeneralSettingsDTO;
    financeSettings?: FinanceSettingsDTO;
    operationalFileSettings?: OperationalFileSettingsDTO;
    quoteFileSettings?: QuoteFileSettingsDTO;
    courierServicesTenantConfiguration?: CourierServicesTenantConfigurationDTO;
    externalContainersSearchSetting?: ExternalContainersSearchSettingDTO;
    containerPickupSettings?: ContainerPickupSettingsDTO;
    moduleSettings?: ModuleSettingsDTO;
    onTimeLogisticsSettings?: OnTimeLogisticsSettingsDTO;
    integrationTypes?: Array<ClientTenantConfigurationDTO.IntegrationTypesEnum>;
}
export namespace ClientTenantConfigurationDTO {
    export type IntegrationTypesEnum = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | '13' | '14';
    export const IntegrationTypesEnum = {
        _0: '0' as IntegrationTypesEnum,
        _1: '1' as IntegrationTypesEnum,
        _2: '2' as IntegrationTypesEnum,
        _3: '3' as IntegrationTypesEnum,
        _4: '4' as IntegrationTypesEnum,
        _5: '5' as IntegrationTypesEnum,
        _6: '6' as IntegrationTypesEnum,
        _7: '7' as IntegrationTypesEnum,
        _8: '8' as IntegrationTypesEnum,
        _9: '9' as IntegrationTypesEnum,
        _10: '10' as IntegrationTypesEnum,
        _11: '11' as IntegrationTypesEnum,
        _12: '12' as IntegrationTypesEnum,
        _13: '13' as IntegrationTypesEnum,
        _14: '14' as IntegrationTypesEnum
    };
}